import { Component, OnDestroy, OnInit } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { DemoModalService } from '../../core/demo-modal.service';

const CERT = 'assets/img/certificado/';

// Vídeo del certificado por idioma (YouTube), igual que el Home.
const VIDEO_IDS: Record<string, string> = {
  es: 'K368eaTrNQU',
  en: 'OpPc4G_linw',
};

@Component({
  selector: 'app-certificado',
  templateUrl: './certificado.component.html',
  styleUrls: ['./certificado.component.scss'],
})
export class CertificadoComponent implements OnInit, OnDestroy {
  playing = false;
  videoUrl: SafeResourceUrl | null = null;

  readonly introImg = 'assets/img/home/expedicion_01.jpg';

  // Imagen del certificado (hero y "Real example"), con versión por idioma:
  // la captura del certificado muestra sus textos en el idioma activo.
  private readonly HERO_DOCS: Record<string, string> = {
    es: CERT + 'certificado_nadorcott_V4.png',
    en: CERT + 'certificado_nadorcott_V4_eng.png',
  };
  get heroDoc(): string {
    return this.HERO_DOCS[this.translate.currentLang] ?? this.HERO_DOCS['es'];
  }

  // Póster inicial del vídeo, con versión por idioma (la captura muestra el
  // certificado con los textos en el idioma activo de la página).
  private readonly POSTERS: Record<string, string> = {
    es: CERT + 'video_packcert_poster.png',
    en: CERT + 'video_packcert_poster_en.png',
  };
  get poster(): string {
    return this.POSTERS[this.translate.currentLang] ?? this.POSTERS['es'];
  }

  readonly flowSteps = [0, 1, 2, 3];
  readonly points = [0, 1, 2, 3];
  readonly bcChecks = [0, 1, 2, 3];

  private langSub?: Subscription;

  constructor(
    private readonly demo: DemoModalService,
    private readonly sanitizer: DomSanitizer,
    private readonly translate: TranslateService,
  ) {}

  ngOnInit(): void {
    // Si se cambia de idioma con el vídeo en marcha, se recarga con el del nuevo idioma.
    this.langSub = this.translate.onLangChange.subscribe(() => {
      if (this.playing) {
        this.videoUrl = this.buildVideoUrl();
      }
    });
  }

  /** Reproduce el vídeo embebido en el marco, según el idioma activo (igual que el Home). */
  playVideo(): void {
    if (this.playing) {
      return;
    }
    this.videoUrl = this.buildVideoUrl();
    this.playing = true;
  }

  private buildVideoUrl(): SafeResourceUrl {
    const id = VIDEO_IDS[this.translate.currentLang] ?? VIDEO_IDS['es'];
    return this.sanitizer.bypassSecurityTrustResourceUrl(
      `https://www.youtube-nocookie.com/embed/${id}?rel=0&modestbranding=1&autoplay=1`,
    );
  }

  openDemo(): void {
    this.demo.open();
  }

  ngOnDestroy(): void {
    this.langSub?.unsubscribe();
  }
}
